import {useEffect, useRef, useContext} from 'react';
import {useLocation} from 'react-router-dom';
import {doc, updateDoc, serverTimestamp} from 'firebase/firestore';

import {db} from '-/firebase';
import {UserContext} from '-/contexts/User';

const TEN_MINUTES = 10 * 60 * 1000;

export default function useActivityTracker() {
    const {currentUser} = useContext(UserContext);
    const location = useLocation();
    const lastWriteRef = useRef(0);

    useEffect(() => {
        if (!currentUser?.uid || currentUser.isStation) {
            return;
        }

        const now = Date.now();
        if (now - lastWriteRef.current < TEN_MINUTES) {
            return;
        }

        lastWriteRef.current = now;

        const ref = doc(db, 'users', currentUser.uid);
        updateDoc(ref, {lastActiveAt: serverTimestamp()}).catch(() => {});
    }, [location, currentUser?.uid, currentUser?.isStation]);
}
